import React, { useState } from "react";
import { Card, Typography, Button, Space } from "antd";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";

const { Title } = Typography;

export default function TotalLeaves() {
    const organisationwise = {
        BFMS: { cl: 15, sl: 8, el: 0, lop: 2, permission: 12 },
        BVPL: { cl: 10, sl: 3, el: 2, lop: 1, permission: 15 },
        BCPL: { cl: 15, sl: 5, el: 3, lop: 0, permission: 3 },
    };

    const orgNames = Object.keys(organisationwise);
    const [currentOrgIndex, setCurrentOrgIndex] = useState(0);

    const handleNext = () => {
        setCurrentOrgIndex((prev) => (prev + 1) % orgNames.length);
    };

    const handlePrev = () => {
        setCurrentOrgIndex((prev) =>
            prev === 0 ? orgNames.length - 1 : prev - 1
        );
    };

    const currentOrg = orgNames[currentOrgIndex];
    const chartData = [
        {
            type: "CL",
            count: organisationwise[currentOrg].cl,
        },
        {
            type: "SL",
            count: organisationwise[currentOrg].sl,
        },
        {
            type: "EL",
            count: organisationwise[currentOrg].el,
        },
        {
            type: "LOP",
            count: organisationwise[currentOrg].lop,
        },
        {
            type: "Permission",
            count: organisationwise[currentOrg].permission,
        },
    ];

    return (
        <>
            <center>
                <Space style={{ marginBottom: "10px" }}>
                    <Button
                        icon={<LeftOutlined />}
                        onClick={handlePrev}
                        shape="circle"
                        type="primary"
                    />
                    <Title level={5} style={{ margin: "0 15px" }}>
                        {currentOrg}
                    </Title>
                    <Button
                        icon={<RightOutlined />}
                        onClick={handleNext}
                        shape="circle"
                        type="primary"
                    />
                </Space>
            </center>


            <ResponsiveContainer width="100%" height={180}>
                <BarChart
                    data={chartData}
                    margin={{
                        top: 20,
                        right: 20,
                        left: 10,
                        bottom: 5,
                    }}
                >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="type" />
                    <YAxis />
                    <Tooltip />
                    <Bar dataKey="count" fill="#1890ff" barSize={50} />
                </BarChart>
            </ResponsiveContainer>
                  <center><Title level={5}>Employee Leave Status</Title></center>

        </>
    );
}
